<template>
  <div class="music">
    <h1>Link music service</h1>
    <MusicLink/>
  </div>
</template>
<script>
  import MusicLink from '../components/MusicLink.vue'

  export default {
    name: 'music',
    components: {
      MusicLink
    }
  }
</script>
